import { render, staticRenderFns } from "./Helper.vue?vue&type=template&id=67202d55"
import script from "./Helper.vue?vue&type=script&setup=true&lang=js"
export * from "./Helper.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67202d55')) {
      api.createRecord('67202d55', component.options)
    } else {
      api.reload('67202d55', component.options)
    }
    module.hot.accept("./Helper.vue?vue&type=template&id=67202d55", function () {
      api.rerender('67202d55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/tooltips/Helper.vue"
export default component.exports